import { atom } from "recoil";
import { Theme } from "../types/Theme";

export const themeState = atom<Theme>({
  key: "theme",
  default: Theme.LightMode,
});
